/* eslint-disable no-console */
import { get, set } from 'lodash';

import DataDogLogs from 'utils/DataDogLogs';
import Environment from 'utils/Environment';
import { parseQueryString } from 'utils/Url';

const _cache = {};

const Log = class {
  static get loggingOverride() {
    if (!get(_cache, ['urlParams'])) {
      set(_cache, ['urlParams'], parseQueryString());
    }

    return get(_cache, ['urlParams', 'logging']) === 'true';
  }

  static get loggingIsEnabled() {
    return !Environment.isProduction || Log.loggingOverride;
  }

  static error = (error, customMessage) => {
    DataDogLogs.error(customMessage, null, error);
    if (customMessage) {
      console.warn(customMessage);
    }
    console.error(error);
  };

  static warn = (warning, error) => {
    DataDogLogs.warn(warning, null, error);
    console.warn(warning);
  };

  static debug = (...args) => {
    if (Log.loggingIsEnabled) {
      console.debug(...args);
    }
  };
};

export default Log;

export { _cache };
